import BulletPointContentBlock from './BulletPointContentBlock'

export default BulletPointContentBlock
